/**
 * Чьи ставки показывает экран: объекта, по умолчанию для холдинга или объект
 * ещё не выбран. Хранится в адресе: `?object=<id>` или `?object=default`.
 */
export type RatesScope =
  { kind: 'project'; projectId: string } | { kind: 'default' } | { kind: 'none' };

/** Ставки, которые задаёт и читает панель группы: объекта или по умолчанию. */
export type RateTarget = { kind: 'project'; projectId: string; name: string } | { kind: 'default' };

export const DEFAULT_OBJECT = 'default';

export function scopeFromParam(raw: string | null): RatesScope {
  if (raw === DEFAULT_OBJECT) return { kind: 'default' };
  if (raw) return { kind: 'project', projectId: raw };
  return { kind: 'none' };
}

/** `project_id` для `GET /group-rates`: id объекта или `default`. */
export function targetKey(target: RateTarget): string {
  return target.kind === 'project' ? target.projectId : DEFAULT_OBJECT;
}

/** «объект «ДГП-2»» / «по умолчанию для холдинга» — в подписи панели. */
export function targetLabel(target: RateTarget): string {
  return target.kind === 'project' ? `Объект «${target.name}»` : 'По умолчанию для холдинга';
}
